import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import ReviewerWaitForWithdrawTableWidget from '../../widgets/admin/ReviewerWaitForWithdrawTableWidget'
import WithdrawalByReviewerPanel from '../../widgets/admin/WithdrawalByReviewerPanel'
import { getReviewerPaymentDetailByReviewer } from '../../redux/actions/withdrawReviewPayment'
import { sessionGetItemJSON, sessionRemoveItem } from '../../utils/sessionHelpers'

export default function ApproveWithdrawReviewByReviewer() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [showTableDetail, setShowTableDetail] = useState(true)
  const [reviewerData, setReviewerData] = useState()
  const [status, setStatus] = useState()
  const code = localStorage.getItem('thp_user_code')
  const projectReviewerPayment = sessionGetItemJSON('projectReviewerPayment')

  useEffect(() => {
    console.log('projectReviewerPayment', projectReviewerPayment)
    if (projectReviewerPayment && projectReviewerPayment?.paymentType == 1) {
      let rowData = {
        id: projectReviewerPayment.projectReviewerPaymentId || '',
        personId: projectReviewerPayment.masterReviewerId || '',
        firstName: '',
        lastName: '',
        status: parseInt(projectReviewerPayment.status) || 0,
      }
      handleOnSelectedRowData(rowData, rowData.status)
      sessionRemoveItem('projectReviewerPayment')
    } else {
      handleGetSchema()
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = {
        projectReviewerPaymentId: null,
        masterReviewerId: null,
        status: 0,
      }
      const response = await getReviewerPaymentDetailByReviewer(request)
      setSchema(response.model)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errorMessage,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnSelectedRowData = async (rowData, status) => {
    setIsLoading(true)
    startLoading()
    setReviewerData()
    try {
      console.log(rowData)
      let request = {
        // personId: rowData.personId,
        budgetYear: rowData.budgetYear,
        // isReviewOnline: rowData.isReviewOnline,
        projectReviewerPaymentId: rowData.id,
        masterReviewerId: rowData.personId,
        status: status || 2,
      }
      //get project by reviewer id
      const response = await getReviewerPaymentDetailByReviewer(request)

      //response.model.forms.projectBudgetPlan.masterBudgetPlan.label = 'แผนงบประมาณ'

      setShowTableDetail(false)
      setReviewerData(rowData)
      setStatus(status)
      setSchema(response.model)
      //setSchema(mockSchemaProjectList.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnCancelShowTable = () => {
    setShowTableDetail(true)
    setReviewerData()
  }

  if (error) {
    return (
      <SidebarProposal isReviewPayment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReviewPayment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isReviewPayment>
      <ContentHeader
        header={
          code === 'THP-SystemAdmin' ||
          code === 'THP-CallCenter' ||
          code === 'THP-DeptAdmin' ||
          code === 'THP-Manager' ||
          code === 'THP-AsstManager'
            ? 'อนุมัติเบิกจ่ายค่าตอบแทนการทบทวนโครงการ (รายผู้ทรงฯ)'
            : schema.header
        }
        subHeader={schema.subHeader}
      />

      <Panel
        header={
          code === 'THP-SystemAdmin' ||
          code === 'THP-CallCenter' ||
          code === 'THP-DeptAdmin' ||
          code === 'THP-Manager' ||
          code === 'THP-AsstManager'
            ? 'อนุมัติเบิกจ่ายค่าตอบแทนการทบทวนโครงการ (รายผู้ทรงฯ)'
            : schema.header
        }
        shaded
        collapsible
        bordered
        defaultExpanded
      >
        <ReviewerWaitForWithdrawTableWidget
          onSelectedRowData={handleOnSelectedRowData}
          isApproveTable={true}
          onShow={showTableDetail}
          onChangeShow={() => setShowTableDetail(!showTableDetail)}
          statusOptions={schema?.forms?.statusOptions || []}
          statusOptionsForApprover={schema?.forms?.statusOptionsForApprover || []}
        />
        <br />
        {schema.forms && reviewerData && (
          <WithdrawalByReviewerPanel
            schema={schema.forms}
            reviewerData={reviewerData}
            onCancelShowTable={handleOnCancelShowTable}
            isApprove={true}
            status={status}
            approveSuccess={(status) => setStatus(status)}
          />
        )}
        <br />
      </Panel>
    </SidebarProposal>
  )
}
